import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from 'seagull/components/Typography';
import { draftLogicTextsPath, validateReviewers } from '~/business-logic/draftLogic';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import { renderAdditionalRecipientsModal } from './AdditionalRecipientsCell.utils';
export function AdditionalRecipientsCell(param) {
    let { draft, contact, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t: draftCellsTexts } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const { t: editTableTexts } = useLocaleKeys('pages.draftsDashboard.editTable');
    const { t: validationTexts } = useLocaleKeys(draftLogicTextsPath);
    const numReviewers = draft.reviewers().length;
    const primaryContact = contact || undefined;
    const openRecipientsModal = ()=>onOpenModal({
            width: '800px',
            shouldSubmit: (draft)=>Promise.resolve(validateReviewers(draft.reviewers(), primaryContact, validationTexts)),
            renderContent: (param)=>{
                let { wasSubmitted, draft, setDraft } = param;
                return renderAdditionalRecipientsModal({
                    draft,
                    setDraft,
                    wasSubmitted,
                    title: draftCellsTexts.additionalRecipients(),
                    primaryContact
                });
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-additional-recipients-".concat(index),
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        onClick: openRecipientsModal,
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: "additional-recipients-".concat(index),
            skin: numReviewers ? 'standard' : 'secondary',
            children: numReviewers ? editTableTexts.additionalRecipientsCount({
                count: numReviewers
            }) : editTableTexts.notSet()
        })
    });
}
